<template>
  <svg :width="size" :height="size" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clip-path="url(#clip0_4092_1989)">
      <path
        d="M4.625 6.375L7.25 9L9.875 6.375"
        stroke="currentColor"
        stroke-width="1.15"
        stroke-linecap="round"
        stroke-linejoin="round" />
      <path d="M7.25 9V2" stroke="currentColor" stroke-width="1.15" stroke-linecap="round" stroke-linejoin="round" />
      <path
        d="M2 10.75C5.40375 11.8875 9.09625 11.8875 12.5 10.75"
        stroke="currentColor"
        stroke-width="1.15"
        stroke-linecap="round"
        stroke-linejoin="round" />
    </g>
    <defs>
      <clipPath id="clip0_4092_1989">
        <rect width="14" height="14" fill="white" />
      </clipPath>
    </defs>
  </svg>
</template>

<script setup>
  defineProps({
    size: {
      type: Number,
      default: 14,
    },
  });
</script>
